import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const isMobileApp = () => {
  return !!(window as any).Capacitor;
};

const MobileAuthHandler: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation('login');

  useEffect(() => {
    if (!isMobileApp()) return;

    const setupDeepLinks = async () => {
      const { App: CapApp } = await import('@capacitor/app');

      await CapApp.addListener('appUrlOpen', (data) => {
        try {
          const url = new URL(data.url);

          if (url.pathname.includes('/auth/google/callback')) {
            const searchParams = url.search;
            const code = url.searchParams.get('code');
            const error = url.searchParams.get('error');

            if (code || error) {
              navigate(`/auth/google/callback${searchParams}`, { replace: true });
            }
          } else if (url.pathname.includes('/auth/google/account-linking-callback')) {
            const searchParams = url.search;
            navigate(`/auth/google/account-linking-callback${searchParams}`, { replace: true });
          }
        } catch (err) {
          console.error('MobileAuthHandler deep link error:', err);
          toast.error(i18n.t('mobileAuthHandler.deepLinkError'));
        }
      });
    };

    void setupDeepLinks();

    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');

    if (code || error) {
      // Navigation handled by the target route component when the router already has the URL.
    }
  }, [i18n, location, navigate]);

  return null;
};

export default MobileAuthHandler;
